import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=122b9e8e&scoped=true"
import script from "./NotificationAdd.vue?vue&type=script&lang=ts"
export * from "./NotificationAdd.vue?vue&type=script&lang=ts"
import style0 from "./NotificationAdd.vue?vue&type=style&index=0&id=122b9e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b9e8e",
  null
  
)

export default component.exports